// extracted by mini-css-extract-plugin
export default {"container":"mC-z","dimension":"nC-z","dimensionLabels":"oC-z"};